<div [class]="'avatar overline-o4 ' + style + ' '" [ngClass]="size ? ('avatar--' + size) : ''">
  <img class="avatar_image" *ngIf="type === 'image' || (type === 'icon' && data.includes('/'))" [src]="data" alt="'image'">
  <mat-icon *ngIf="type === 'icon' && !data.includes('/')" [svgIcon]="data" [class]="style" [color]="color"></mat-icon>
  <div *ngIf="type === 'initials' || type === 'iconInitials'">{{Helper.getInitials(data)}}</div>
</div>
